import React from 'react';
import PropTypes from 'prop-types';

import styles from './CloseButton.module.css';

const CloseButton = ({ onClick, style }) => (
  <button
    type="button"
    name="close-button"
    className={styles.button}
    style={style}
    onClick={onClick}
  >
    <i className="far fa-times" />
  </button>
);

CloseButton.propTypes = {
  onClick: PropTypes.func,
  style: PropTypes.shape({}),
};

CloseButton.defaultProps = {
  onClick: () => {},
  style: {},
};

export default CloseButton;
